import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function GatePassesPage(){return <ExtendedModulePage moduleKey="gate-passes"/>}
